
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dermatology",
      function () {
        return require("private-next-pages/dermatology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dermatology"])
      });
    }
  